import configureStore from './store';
export const Store = configureStore();
